import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { FirmService } from '../../../../Services/firm.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';

@Component({
  selector: 'app-account-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, FormsModule],
  templateUrl: './account-layout.component.html',
  styleUrl: './account-layout.component.css',
})
export class AccountLayoutComponent implements OnInit {
  firms: any[] = [];
  selectedFirmId: any = '';

  constructor(
    private router: Router,
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService
  ) { }

  ngOnInit(): void {
    this.getFirms();
    // Subscribe to firm selection changes
    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      if (firm) {
        this.selectedFirmId = firm.id;
      } else {
        this.selectedFirmId = '';
      }
    });

    // Handle initial load if already in localStorage
    const storedFirmId = localStorage.getItem('firm_id');
    if (storedFirmId) {
      this.selectedFirmId = Number(storedFirmId);
    }
  }

  getFirms() {
    this.firmService.getFirms().subscribe({
      next: (res: any) => {
        this.firms = res.data || [];
      }
    });
  }

  onFirmSelect(event: any) {
    const firmId = event.target.value;
    if (firmId === '') {
      // Logic for "All Firms" - depending on how the services handle it
      // Usually passing null or clearing the selection
      localStorage.removeItem('firm_id');
      // this.firmSelectionService.setselectedFirmName(null as any); // Service expects non-null
    } else {
      const selectedFirm = this.firms.find(f => f.id == firmId);
      if (selectedFirm) {
        this.firmSelectionService.setselectedFirmName({
          id: selectedFirm.id,
          name: selectedFirm.name,
          status: selectedFirm.gst_status
        });
      }
    }
  }

  onTabChange(event: Event) {
    const path = (event.target as HTMLSelectElement).value;
    this.router.navigateByUrl(path);
  }
}
